import { toast } from "react-toastify";
import { _AttentionPointAgenda } from "../../../../../../../../core/services/dataBean/QuickEntityCatalog";
import useDataBean from "../../../../../../../../core/services/dataBean/useDataBean";
import { Alert } from "../../../../../../../../modules/theme/Component/Alert";
import { useEffect } from "react";
import "./SelectCardAppointments.css";

interface ComponentData {
    ServiceIDLn: number;
    SelectedDay: string;
    IDAppointment?: number;
    onChange: (item: any) => void;
}

export const SelectCardAppointments = ({ ServiceIDLn, onChange, SelectedDay, IDAppointment }: ComponentData) => {
    const { instance, setBean, bean, lista, setLista } = useDataBean(_AttentionPointAgenda);

    useEffect(() => {
        if (ServiceIDLn && SelectedDay) {
            getListaHours();
        }
    }, [ServiceIDLn, SelectedDay]);

    const getListaHours = () => {
        instance
            .getAppointments(ServiceIDLn, `${SelectedDay} 00:00:00`, IDAppointment ?? null)
            .then((resp) => {
                setLista(resp || []);
                console.log(resp);
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    const functionClick = (item: any) => {
        setBean(item);
        onChange?.(item);
    };

    const getHour = (dateStr: string) => {
        if (!dateStr) return "";
        const parts = dateStr.split(" ");
        if (parts.length < 2) return dateStr;
        return parts[1].substring(0, 5);
    };

    const listaFiltrada = (lista || []).filter(
        (item: any) => item.DataBeanProperties?.State === 0
    );

    return (
        <>
            {listaFiltrada.length > 0 ? (
                <div className="d-flex gap-2 flex-wrap mt-2">
                    {listaFiltrada.map((item: any, index: number) => {
                        const data = item.DataBeanProperties;
                        const isSelected = bean.IDAttentionTimeLapse === data.IDAttentionTimeLapse;

                        const fromHour = getHour(data.FromDate);
                        const untilHour = getHour(data.UntilDate);

                        return (
                            <div
                                key={index}
                                className={`p-2 rounded shadow-sm day-card ${isSelected ? "selected" : ""}`}
                                style={{ width: "140px", cursor: "pointer" }}
                                onClick={() => functionClick(data)}
                            >
                                <h6 className="fw-bold mb-1 text-center">
                                    {fromHour} - {untilHour}
                                </h6>

                                <p className="text-center mb-0" style={{ fontSize: "0.75rem" }}>
                                    Disponible
                                </p>
                            </div>
                        );
                    })}
                </div>
            ) : ServiceIDLn ? (
                <Alert clase="info">No hay horarios de apertura disponibles</Alert>
            ) : (
                <Alert clase="warning">Debe seleccionar un servicio</Alert>
            )}
        </>
    );
};
